import React, { useRef } from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core'
import { colors } from '@diversioteam/diversio-ds'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

import { ListItemProps } from './listItem.types'
import * as S from './listItem.styles'

export const ListItem = ({ option }: ListItemProps) => {
    const { t } = useTranslation()

    const accordionRef = useRef<HTMLDivElement>(null)

    const { label, options, icon, path, ...props } = option

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const isExpanded = accordionRef.current?.getAttribute('aria-expanded') === 'true'
        const isTargetIcon = event.target instanceof Element && event.target.className.includes('icon')

        if (isExpanded || isTargetIcon) {
            event.preventDefault()
        }
    }

    if (options !== undefined && options.length > 0) {
        return (
            <S.ListItemWrapper>
                <Accordion>
                    <AccordionSummary ref={accordionRef}>
                        <S.OptionsItem
                            as={NavLink}
                            to={generateCompanyURI(path)}
                            activeClassName="active"
                            onClick={handleClick}
                            aria-haspopup="true"
                            {...props}
                        >
                            <S.ParentBasicOptionsItem>
                                {icon}
                                <S.Label>{t(label)}</S.Label>

                                <S.Expand type="bold" color={colors.primary30} />
                            </S.ParentBasicOptionsItem>
                        </S.OptionsItem>
                    </AccordionSummary>

                    {options?.length && (
                        <AccordionDetails>
                            <S.Group>
                                {options.map(({ label, path, ...props }, key) => {
                                    return (
                                        <S.GroupItem key={key}>
                                            <S.NestedOptionsItem
                                                as={NavLink}
                                                to={generateCompanyURI(path)}
                                                activeClassName="active"
                                                {...props}
                                            >
                                                <S.BasicOptionsItem>
                                                    <S.Label>{t(label)}</S.Label>

                                                    <S.Expand type="bold" color={colors.primary30} />
                                                </S.BasicOptionsItem>
                                            </S.NestedOptionsItem>
                                        </S.GroupItem>
                                    )
                                })}
                            </S.Group>
                        </AccordionDetails>
                    )}
                </Accordion>
            </S.ListItemWrapper>
        )
    }

    return (
        <S.ListItemWrapper>
            <S.OptionsItem as={NavLink} activeClassName="active" to={generateCompanyURI(path)} {...props}>
                <S.BasicOptionsItem {...props}>
                    {icon}
                    <S.Label>{t(label)}</S.Label>
                </S.BasicOptionsItem>

                {option?.customNavContent && <S.CustomSlotContent>{option?.customNavContent}</S.CustomSlotContent>}
            </S.OptionsItem>
        </S.ListItemWrapper>
    )
}
